<!-- vertical layout -->
<app-vertical-layout [layoutWidth]="layoutWidth">
</app-vertical-layout>
<ngx-spinner name="global"  bdColor = "rgba(0, 0, 0, 0.9)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Ładuje... </p></ngx-spinner>
